import { useEffect, useRef } from 'react';

/**
 * It creates a Ref which you can add as ref prop on your component
 * Clicking anywhere outside of "wrapped div" will trigger callback call
 *
 * Example of usage:
 * const ref = useOutsideClick(() => 'clicked outside');
 * return <div ref={ref}>wrapped div</div>
 */
export function useOutsideClick(callback: () => void) {
  const wrapperRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      const mouseEvent = event as MouseEvent & { target: HTMLElement };
      if (
        wrapperRef.current &&
        !(wrapperRef.current as HTMLElement).contains(mouseEvent.target)
      ) {
        callback();
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [wrapperRef, callback]);

  return wrapperRef;
}
